import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import './vendor';


if (environment.production) {
    enableProdMode();
}

declare var $: any;

const p = platformBrowserDynamic().bootstrapModule(AppModule);
p.then(() => {
  (<any>window).appBootstrap && (<any>window).appBootstrap();

  $(document).scroll(() => {

    let nav = $('.topnavbar').height();
    let offset = $(document).scrollTop() + nav;
    let headers = $('thead.fixed');

    headers.each(i => {

      let header = $(headers[i]);
      let top = Math.max(offset - header.offset().top, 0);

      let max = header.parent().outerHeight() - header.parent().find('td').last().outerHeight() - header.find('th').outerHeight();

      if (top < max) header.find('th').css({ top: top });
    })
  });
});
